import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { SURVEY_COLORS } from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
interface RecommendationsStylesProps {
  isMobile: boolean;
}

export const useRecommendationsStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: (props: RecommendationsStylesProps) => (props.isMobile ? "16px" : "24px"),
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
      height: "auto",
      overflowY: "visible",
    },
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: "24px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      justifyContent: "flex-start",
    },
  },

  primaryButton: {
    borderRadius: 8,
    fontSize: "13px",
    fontWeight: 600,
    height: 36,
    padding: "0 12px",
    backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
    color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    border: "none",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiButton-endIcon": {
      marginLeft: "4px",
      "& svg": {
        fontSize: "12px !important",
      },
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
  },

  recommendationCard: {
    marginBottom: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderTop: `4px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(0.5),
    borderRadius: 8,
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    maxHeight: "none",
  },
  cardActions: {
    justifyContent: "flex-end",
    display: "flex",
    padding: theme.spacing(0.5, 1),
    borderTop: "none",
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  loadingContainer: {
    padding: theme.spacing(8, 2),
    textAlign: "center",
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(0.5),
    },
  },
  icon: {
    width: 64,
    height: 64,
    color: "#00338D",
    animation: "$spin 2s linear infinite",
  },
  title: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    fontWeight: 600,
  },
  searchingLabel: {
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    fontSize: "0.95rem",
  },

  searchingRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    width: "100%",
  },
  // progress bar wrapper (div-based)
  progressTrack: {
    height: 8,
    background: "#e0e0e0",
    borderRadius: 999,
    overflow: "hidden",
    width: 240,
    maxWidth: "60%",
  },
  description: {
    display: "-webkit-box",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
  },
  contentBox: {
    border: "none",
    borderRadius: 0,
    padding: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    backgroundColor: "transparent",
    boxSizing: "border-box",
    marginBottom: 0,
  },
  cardContent: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  cardsList: {
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: (props: RecommendationsStylesProps) =>
      props.isMobile ? "none" : "calc(90vh - 320px)",
    paddingRight: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  emptyState: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  headerDescription: {
    fontSize: "14px",
    color: SURVEY_COLORS.TEXT_SECONDARY,
    marginBottom: "16px",
    textAlign: "center",
  },
  header: {
    fontSize: "16px",
    color: SURVEY_COLORS.TEXT_PRIMARY,
    marginBottom: "16px",
    textAlign: "center",
    fontWeight: "bold",
  },
  progressFill: {
    height: "100%",
    background: SURVEY_COLORS.BUTTON_PRIMARY,
    borderRadius: 999,
    transition: "width 0.5s ease-out",
  },
  progressFillError: {
    height: "100%",
    background: theme.palette.error.main,
    borderRadius: 999,
    transition: "width 0.5s ease-out",
  },
  progressStyle: { position: "absolute", width: 1, height: 1, opacity: 0, pointerEvents: "none" },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));
